import { memberLabel } from './format';

const SHOWN_VALUES = 3;

function listSummary(values: Array<string>): string {
  const shown = values.slice(0, SHOWN_VALUES).map(memberLabel).join(', ');
  return values.length > SHOWN_VALUES ? `${shown} and ${values.length - SHOWN_VALUES} more` : shown;
}

/** Only infer a complement when the available choices are known to be complete. */
export default function filterSelectionSummary(
  picked: Array<string>,
  options: Array<string> = [],
  complete = false,
): string {
  const selected = [...new Set(picked)];
  if (!selected.length) return 'All';
  const available = [...new Set(options)];
  const known = new Set(available);
  if (complete && available.length && selected.every((value) => known.has(value))) {
    const included = new Set(selected);
    const excluded = available.filter((value) => !included.has(value));
    if (!excluded.length) return 'All';
    if (excluded.length < selected.length) return `All except ${listSummary(excluded)}`;
  }
  return listSummary(selected);
}
